// GENERATED by sortswift-buylist-api scripts/vendor-buylist-walk.js. DO NOT EDIT.
//
// The buylist's tier walk (TKT-2026-107051): what a line of several copies is worth on the
// store's quantity ladder, with the offer and money rounding it uses. The server books every
// order with these exact bytes. It is built from these files in sortswift-buylist-api, the
// only place to change it:
//   src/buylistEngine/offerRounding.js
//   src/buylistEngine/currencyPriceGrid.js
//   src/utils/buylistMoneyRounding.js
//   src/utils/buylistTieredLine.js
// A copy edited here quotes a customer one figure while the order books another, which is
// the defect this file exists to end. To update, change the walk there, merge it, and
// re-run the command in that script's header; then set the new body digest in this repo's
// vendor test.
//
// source: mtechcave/sortswift-buylist-api@1d3057171e020b1c40b678badf5a4c01bf1aa314
// body-sha256: f2251157b983dd36d06d31aee781c35e4346c672c51533b5a1ab420ebe695fd0
/* eslint-disable */
// ---- BEGIN VENDORED BODY ----
// ---- src/buylistEngine/offerRounding.js ----
const __offerRounding = (function () {
// src/utils/offerRounding.js
//
// Snap a buylist OFFER (cash or credit) to a store-configured increment.
// Adapted from the autopricing roundUp executor, but parametrized by direction
// and defaulting to NEAREST: this is a BUY price, so rounding UP overpays the
// customer and DOWN can shortchange them, making nearest the honest default.
// Only percentage-derived offers should be passed here; callers must leave fixed
// price rules, fixed bulk rules, and by-appointment offers untouched.

// 0.01 is intentionally excluded: it (and any missing/invalid value) means
// "no rounding" for buylist, so low bands left at 0.01 keep their exact value.
// 5.0 is included so stores that rounded whole-dollar buys to the nearest $5
// under the old roundUp keep rounding (now to nearest) instead of silently
// losing their increment.
const VALID_ROUNDING = new Set([0.05, 0.1, 0.25, 0.49, 0.5, 0.95, 0.99, 1.0, 5.0]);

function roundPlain(value, step, direction) {
  const q = value / step;
  let n;
  if (direction === 'down') n = Math.floor(q + 1e-9);
  else if (direction === 'up') n = Math.ceil(q - 1e-9);
  else n = Math.round(q); // nearest, halves up
  return Number((n * step).toFixed(2));
}

function psychologicalRungs(value, step) {
  const intPart = Math.floor(value);
  const rungs = [];
  for (let x = intPart - 1; x <= intPart + 1; x++) {
    if (step === 0.49) rungs.push(x + 0.49, x + 0.99);
    else rungs.push(x + step); // 0.95 or 0.99
  }
  return rungs.filter((r) => r > 0).sort((a, b) => a - b);
}

function roundPsychological(value, step, direction) {
  const rungs = psychologicalRungs(value, step);
  if (!rungs.length) return Number(value.toFixed(2));
  let chosen;
  if (direction === 'down') {
    const below = rungs.filter((r) => r <= value + 1e-9);
    chosen = below.length ? below[below.length - 1] : rungs[0];
  } else if (direction === 'up') {
    const above = rungs.filter((r) => r >= value - 1e-9);
    chosen = above.length ? above[0] : rungs[rungs.length - 1];
  } else {
    chosen = rungs.reduce(
      (best, r) => (Math.abs(r - value) < Math.abs(best - value) ? r : best),
      rungs[0]
    );
  }
  return Number(chosen.toFixed(2));
}

/**
 * Round a computed buylist offer to a configured increment.
 * @param {number} value - offer AFTER all modifiers
 * @param {number} step - increment; 0.01/missing/invalid => returned unchanged
 * @param {('nearest'|'down'|'up')} [direction='nearest']
 * @returns {number}
 */
function roundOffer(value, step, direction = 'nearest') {
  const v = Number(value);
  const s = Number(step);
  if (!Number.isFinite(v) || v <= 0) return v;
  if (!VALID_ROUNDING.has(s)) return v; // 0.01 / invalid => no rounding
  const dir = direction === 'down' || direction === 'up' ? direction : 'nearest';
  if (s === 0.49 || s === 0.95 || s === 0.99) return roundPsychological(v, s, dir);
  return roundPlain(v, s, dir);
}

// Resolve the effective increment for one offer.
// An EXPLICIT per-range choice is authoritative, including "no rounding" (0.01 or
// 0): a band the store set to 0.01 stays unrounded even when a game-level default
// exists, which is what makes the "round only bands over $X" pattern work. Only a
// range with NO explicit choice ('', null, undefined, 'inherit') falls back to the
// game-level pricingOptions.rounding, so stores that configured only the game-level
// control keep working. Anything not a valid step resolves to 0.01 (no rounding).
function resolveIncrement(rangeRounding, gameRounding) {
  const hasRange =
    rangeRounding !== undefined &&
    rangeRounding !== null &&
    rangeRounding !== '' &&
    rangeRounding !== 'inherit';
  if (hasRange) {
    const r = Number(rangeRounding);
    return VALID_ROUNDING.has(r) ? r : 0.01;
  }
  const g = Number(gameRounding);
  return VALID_ROUNDING.has(g) ? g : 0.01;
}

return { roundOffer, resolveIncrement, VALID_ROUNDING };
})();

// ---- src/buylistEngine/currencyPriceGrid.js ----
const __currencyPriceGrid = (function () {
'use strict';

// File: src/utils/currencyPriceGrid.js
//
// TKT-2026-106987: the store currency's price grid for the V1 autoprice writers
// (utils/pricing.js), the consignor card detail and the buylist offer grid
// (buylistOfferGrid.js), standalone so this file and the files that use it are
// byte-identical in sortswift-api, sortswift-inventory-api and sortswift-buylist-api
// (neither of which carries the V2 engine).
//
// The same definition as priceGridDigits in pricingEngineV2/pricing-calculator-v2.util.js:
// the digit count comes from Intl, capped at the cent. JPY/KRW/CLP/ISK are whole units,
// every two-decimal currency (and KWD/BHD, which can express a cent) keeps the cent, and an
// unknown code keeps the cent. test/tkt-2026-106987-v1-rates-fail-closed.test.js pins it to
// the engine's answer for every ISO code in sortswift-api.

const digitsCache = new Map();

function priceGridDigits(code) {
  const key = String(code || 'USD').trim().toUpperCase() || 'USD';
  const cached = digitsCache.get(key);
  if (cached !== undefined) return cached;
  let digits = 2;
  try {
    const resolved = new Intl.NumberFormat('en-US', { style: 'currency', currency: key })
      .resolvedOptions().maximumFractionDigits;
    if (Number.isInteger(resolved) && resolved >= 0 && resolved <= 4) digits = resolved;
  } catch {
    digits = 2;
  }
  digits = Math.min(digits, 2);
  digitsCache.set(key, digits);
  return digits;
}

return { priceGridDigits };
})();

// ---- src/utils/buylistMoneyRounding.js ----
const __buylistMoneyRounding = (function () {
'use strict';

// File: src/utils/buylistMoneyRounding.js
//
// The money grid half of buylistMoney.js (TKT-2026-106987), on its own so it
// depends on nothing but currencyPriceGrid. buylistMoney.js re-exports all three,
// so callers that require them from there are unchanged.
//
// It is standalone because the tier walk (buylistTieredLine.js) rounds with it,
// and that walk is vendored byte for byte into the kiosk and both storefronts
// by scripts/vendor-buylist-walk.js (TKT-2026-107051). Everything this file
// requires ships to three frontends, so it must stay free of the engine, the
// models and anything that reads a user doc. Pinned by
// test/buylist-tier-walk-vendor.test.js.
//
// The rule (see buylistMoney.js for the full history):
//   - A whole-unit currency (JPY/KRW/CLP/ISK, from priceGridDigits) rounds
//     half-up to a whole unit.
//   - Every other currency, and a missing one, keeps EXACTLY the arithmetic it
//     had: 'thousandth' is Number(x.toFixed(3)), 'cent' is
//     Math.round(x * 100) / 100 (the tier ladder), 'fixed-cent' is
//     Number(x.toFixed(2)).

const { priceGridDigits } = __currencyPriceGrid;

function normaliseCode(currency) {
  return String(currency || '').trim().toUpperCase();
}

/** A currency whose grid is a whole unit. A missing currency is not one. */
function isWholeUnitCurrency(currency) {
  const code = normaliseCode(currency);
  return !!code && priceGridDigits(code) === 0;
}

/**
 * Round a buylist order figure onto the store currency's grid.
 * @param {number} value
 * @param {string|null} currency the store currency (buylistConfig.config.storeCurrency)
 * @param {'thousandth'|'cent'|'fixed-cent'} rule what a cent-grid currency keeps (see header)
 */
function roundBuylistMoney(value, currency, rule = 'thousandth') {
  const n = Number(value) || 0;
  if (isWholeUnitCurrency(currency)) {
    // Snap float residue first so 1234.4999999999 and 1234.5 land where a person
    // would put them, then half-up.
    return Math.round(Number(n.toFixed(10)));
  }
  if (rule === 'cent') return Math.round(n * 100) / 100;
  if (rule === 'fixed-cent') return Number(n.toFixed(2));
  return Number(n.toFixed(3));
}

return {
  normaliseCode,
  isWholeUnitCurrency,
  roundBuylistMoney
};
})();

// ---- src/utils/buylistTieredLine.js ----
const __buylistTieredLine = (function () {
// src/utils/buylistTieredLine.js
//
// THE tier walk. This file is the only copy (TKT-2026-107051): the kiosk, the
// hosted storefront and the standalone storefront each carry a byte-for-byte
// vendored build of it, made by scripts/vendor-buylist-walk.js together with
// the rounding it calls (offerRounding, currencyPriceGrid, buylistMoneyRounding).
// They used to carry hand ports, and the ports drifted: the standalone priced
// copies past the last tier at 0 while this walk did not, so a store's card
// showed CA$0.70 and the order booked CA$0.00.
//
// A change here changes what three frontends quote. The body digest is pinned
// by test/buylist-tier-walk-vendor.test.js, which fails until the clients are
// re-vendored and names the command. Keep this file, and the three it
// requires, free of anything a browser cannot run: no models, no engine
// config, no process or fs.
//
// A store's reduction thresholds describe a LADDER. With 3:10% 4:20% 5:40% and
// no stock on hand, a customer selling 5 copies is offered 3 at full price, the
// 4th at -10% and the 5th at -20%. That is what the storefront row and the
// "Tiered Pricing Applied" box show them.
//
// TKT-2026-104614: a line total is not representable as one per-unit price times
// quantity, but everything downstream works exactly that way. `submitBuylistOrder`
// totals `addedCashPrice * quantity`, `calculateBuylistCartTotals` recomputes the
// staff-side figure the same way, the CSV and the emails read the same field, and
// `tieredPricing` / `basePrices` are NOT in the BuylistOrder schema so they never
// survive the save. Nothing after submit can re-walk the ladder.
//
// So the ladder is folded INTO the per-unit offer before totalling: perUnit
// becomes ladderTotal / quantity, which makes `perUnit * quantity` equal the
// ladder by construction. TKT-2026-103600's invariant is preserved exactly (the
// total is still the sum of the per-line offers and is never re-derived from
// tier data after the fact); what changes is that the per-line offer is now
// right on a multi-tier line.
//
// Applying it here as well as on the storefront is what stops a stale cart, a
// cart restored from localStorage weeks later, or a hand-rolled POST to the
// public /submit-order route from quoting a figure we did not compute. That
// holds only because the submit route walks the ENGINE's ladder for a public
// caller, not the one in the request (applyTieredUnitOffers `ladderFor`).

const { roundOffer } = __offerRounding;
const { roundBuylistMoney } = __buylistMoneyRounding;

// TKT-2026-106987: the ladder rounds on the store currency's grid. A cent
// currency, and a caller that passes none, keeps the cent exactly as before; a
// whole-unit currency (JPY) keeps the whole unit.
function roundCurrency(value, currency = null) {
    return roundBuylistMoney(value, currency, 'cent');
}

// The increment the ENGINE used for this exact price key, stamped on the price
// payload as offerRounding.steps (TKT-2026-104270). 0 / missing means the engine
// deliberately left that offer exact, so we leave it exact too.
function getOfferRoundingStep(source, priceKey) {
    const parsed = Number(source?.offerRounding?.steps?.[priceKey]);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

function getOfferRoundingDirection(source) {
    const dir = source?.offerRounding?.direction;
    return dir === 'up' || dir === 'down' ? dir : 'nearest';
}

/** A line only has a ladder to fold in when the engine sent both halves of it. */
function hasTierData(item) {
    return !!(
        item &&
        item.tieredPricing &&
        Array.isArray(item.tieredPricing.tiers) &&
        item.tieredPricing.tiers.length > 0 &&
        item.basePrices
    );
}

/**
 * The condition prefix this line's prices are filed under. Sealed products carry
 * condAbbr 'U' (Unopened) but the engine files their prices under the NM keys,
 * so fall back to NM whenever the line's own condition has no entry in
 * basePrices. Derived from the payload rather than a `sealed` flag so it holds
 * even on an item that lost the flag.
 *
 * `ladder` is where the basePrices come from; see calculateTieredLineTotal.
 */
function resolveTierCondPrefix(item, ladder = item) {
    const cond = String(item?.condAbbr || 'NM').replace(/\s+/g, '') || 'NM';
    const base = ladder?.basePrices || {};
    if (base[`${cond}FinalCash`] == null && base.NMFinalCash != null) return 'NM';
    return cond;
}

/**
 * Walk one cart line across the store's stock-limitation tiers.
 *
 * `ladder` supplies the tier table, the un-reduced basePrices, the stock level
 * the walk starts from and the offer rounding. It defaults to the line itself,
 * which is how the storefront walks its own cart. The submit route passes the
 * ENGINE's re-quote for a public caller instead, because on the wire every one
 * of those fields is the caller's to write (see applyTieredUnitOffers). The line
 * still supplies the quantity and the condition.
 *
 * It returns the walk as well as the total, for a caller that SHOWS the ladder
 * (the standalone storefront's "Tiered Pricing Applied" box): `segments` holds
 * one entry per tier the walk priced copies in, in order, and a last entry with
 * `pastLastTier` for copies past the last tier's end. An untiered line has
 * none. Each segment's subtotal is exactly what the total summed, so a screen
 * built from them can never show a figure the order does not book.
 *
 * `alreadyInCart` is how many copies of the same card EARLIER lines of this
 * cart already walked (cartCountOffsets). This line's walk starts past them, so
 * a store that counts every printing of a card together prices the 12th copy at
 * the 12th copy's rate whichever set it is from (TKT-2026-108650). 0 by default.
 *
 * @param {Object} item cart item carrying quantity / condAbbr / addedCash|CreditPrice
 * @param {string} priceKey e.g. 'NMFinalCash'
 * @param {string|null} currency the store currency (TKT-2026-106987)
 * @param {Object} [ladder] tieredPricing / basePrices / offerRounding source
 * @param {number} [alreadyInCart] copies of this card on earlier lines
 * @returns {{total: number, basePrice: number, segments: Array<{tierIndex: number, units: number, unitPrice: number, subtotal: number, pastLastTier: boolean}>}}
 */
function walkTieredLine(item, priceKey, currency = null, ladder = item, alreadyInCart = 0) {
    const tieredPricing = ladder.tieredPricing;
    const basePrice =
        ladder.basePrices?.[priceKey] ||
        item[
            priceKey
                .replace('Final', 'added')
                .replace('Cash', 'CashPrice')
                .replace('Credit', 'CreditPrice')
        ] ||
        0;
    const inventoryQuantity =
        tieredPricing?.inventoryQuantity || ladder.inventoryQuantity || 0;
    const quantity = Number(item.quantity) || 1;
    const roundingStep = getOfferRoundingStep(ladder, priceKey);
    const roundingDirection = getOfferRoundingDirection(ladder);

    if (!tieredPricing || !Array.isArray(tieredPricing.tiers) || !tieredPricing.tiers.length) {
        return { total: roundCurrency(basePrice * quantity, currency), basePrice, segments: [] };
    }

    // A tier a flat price step covers pays the lower of its flat amount for this
    // tender and the offer it would otherwise get (TKT-2026-108650). The amount is
    // the store's own figure, so offer rounding never moves it; a missing amount
    // (null) caps nothing.
    const flatKey = priceKey.endsWith('Cash') ? 'fixedCash' : priceKey.endsWith('Credit') ? 'fixedCredit' : null;
    const tierUnitPrice = (tier) => {
        const offer = roundCurrency(roundOffer(basePrice * (tier.multiplier || 1.0), roundingStep, roundingDirection), currency);
        const flat = flatKey && tier[flatKey] != null ? Number(tier[flatKey]) : NaN;
        return Number.isFinite(flat) && flat >= 0 ? Math.min(offer, roundCurrency(flat, currency)) : offer;
    };

    const segments = [];
    let total = 0;
    let remainingQty = quantity;
    // start from the store's stock level, past this card's earlier cart lines
    let currentPosition = inventoryQuantity + (Number(alreadyInCart) > 0 ? Number(alreadyInCart) : 0);

    for (let i = 0; i < tieredPricing.tiers.length && remainingQty > 0; i++) {
        const tier = tieredPricing.tiers[i];
        const tierEnd = tier.toQty;

        if (currentPosition >= tierEnd && tierEnd !== null) continue;

        const startInTier = Math.max(currentPosition, tier.fromQty);
        const endInTier =
            tierEnd !== null
                ? Math.min(currentPosition + remainingQty, tierEnd)
                : currentPosition + remainingQty;
        const unitsInTier = Math.max(0, endInTier - startInTier);

        if (unitsInTier > 0) {
            const unitPrice = tierUnitPrice(tier);
            const subtotal = roundCurrency(unitPrice * unitsInTier, currency);
            segments.push({ tierIndex: i, units: unitsInTier, unitPrice, subtotal, pastLastTier: false });
            total += subtotal;
            remainingQty -= unitsInTier;
            currentPosition += unitsInTier;
        }
    }

    // Units past the last tier's end are bought at the last tier's rate, never
    // at 0 (TKT-2026-107051). This walk prices a line; it does not decide
    // whether the store buys it. That is `isStockLimitReached`, which the engine
    // applies to the whole cart quantity and the submit price guard re-asks, so
    // a line past a cap the store STOPS at is refused before it gets here. What
    // reaches this point is a table that closed where nothing refuses: the
    // engine used to end the first tier at the cap with the stop off, and a cart
    // restored from localStorage still carries that table. Walked as it was, a
    // store holding 7 against a cap of 4 had every copy priced at 0 and the
    // order booked at $0 while the storefront card showed the full offer.
    if (remainingQty > 0) {
        const lastIndex = tieredPricing.tiers.length - 1;
        const unitPrice = tierUnitPrice(tieredPricing.tiers[lastIndex]);
        const subtotal = roundCurrency(unitPrice * remainingQty, currency);
        segments.push({ tierIndex: lastIndex, units: remainingQty, unitPrice, subtotal, pastLastTier: true });
        total += subtotal;
    }

    return { total: roundCurrency(total, currency), basePrice, segments };
}

/**
 * The line total of walkTieredLine: what the order books for this line.
 * Same arguments; see there.
 * @returns {number}
 */
function calculateTieredLineTotal(item, priceKey, currency = null, ladder = item, alreadyInCart = 0) {
    return walkTieredLine(item, priceKey, currency, ladder, alreadyInCart).total;
}

/**
 * For each cart line, how many copies of the same card the lines BEFORE it
 * carry: the `alreadyInCart` its walk starts past (TKT-2026-108650).
 *
 * Lines are the same card when their ladders carry the same
 * `tieredPricing.countKey`. The engine sets one only for a store that counts
 * every printing of a card together (stockLimitations.countAllPrintings), so
 * every other cart gets all zeros and walks exactly as before.
 *
 * @param {Array} cart cart items, in order
 * @param {Function|null} [ladderFor] item => the ladder to walk it on, or null
 * @returns {number[]} one offset per line, aligned with `cart`
 */
function cartCountOffsets(cart = [], ladderFor = null) {
    const seen = new Map();
    return cart.map((item) => {
        const ladder = ladderFor ? ladderFor(item) : item;
        const key = hasTierData(ladder) ? ladder.tieredPricing.countKey : null;
        if (typeof key !== 'string' || !key) return 0;
        const before = seen.get(key) || 0;
        const quantity = Number(item?.quantity) || 0;
        seen.set(key, before + (quantity > 0 ? quantity : 0));
        return before;
    });
}

/**
 * Fold each line's ladder into its per-unit offer, IN PLACE, so the totals that
 * follow and the cart that gets saved carry the same money.
 *
 * A line with no ladder to walk is left untouched, which is every stored order
 * (the schema drops tier data) and every store that does not run stock
 * limitations.
 *
 * The per-unit figure stays the ladder's exact share at three decimals in every
 * currency, so `perUnit * quantity` rounds back to the ladder total: a ¥1000
 * ladder over 3 copies is 333.333 each, which calculateTieredTotalForItem folds
 * back to ¥1000 on the yen grid (TKT-2026-106987). Rounding the share to a whole
 * unit instead would make the line total ¥999 and break TKT-2026-103600.
 *
 * WHOSE LADDER. With no `ladderFor`, each line folds its own tier data, which is
 * right for a caller trusted to name its own prices. A public submit must pass
 * `ladderFor`, returning the engine's re-quote for that line or null. The price
 * guard runs BEFORE this fold and checks addedCash/CreditPrice, but the fold
 * never reads those on a tiered line: it rewrites them from basePrices x tier
 * multipliers. So a line that carried an honest price and its own basePrices,
 * multipliers, stock level or rounding passed the guard and was then booked at
 * whatever those produced. A null ladder means the line is not folded, and it
 * books at the addedCash/CreditPrice the guard checked.
 *
 * THE LADDER SOURCE DECIDES, NOT THE LINE (TKT-2026-107051). A public line is
 * folded whenever the engine answered it with a ladder, whether or not the line
 * itself carried one. The kiosk and the storefront served by sortswift-api send
 * no tier data: they submit the engine's single-unit figure, which is the price
 * of the NEXT copy only. Left unfolded, a customer selling 5 copies across a
 * reduction threshold was paid the first copy's price for all 5, while the
 * standalone storefront, which sends the ladder, booked the same cart lower.
 * Walking the engine's ladder cannot double a reduction: it starts from the
 * engine's un-reduced basePrices, never from the figure the line carried. A
 * trusted caller passes no `ladderFor`, so its own untiered lines stay as sent.
 *
 * Lines of one card (the same ladder countKey) walk one after another, each
 * past the copies of the lines before it (cartCountOffsets, TKT-2026-108650).
 *
 * @param {Array} cart cart items, with their final quantities already set
 * @param {string|null} currency the store currency (TKT-2026-106987)
 * @param {Function|null} [ladderFor] item => the ladder to walk it on, or null
 * @param {number[]} [offsets] per-line copies of the same card already walked
 * @returns {number} how many lines were adjusted
 */
function applyTieredUnitOffers(cart = [], currency = null, ladderFor = null, offsets = cartCountOffsets(cart, ladderFor)) {
    let adjusted = 0;

    for (const [index, item] of cart.entries()) {
        const ladder = ladderFor ? ladderFor(item) : item;
        const alreadyInCart = offsets[index] || 0;
        if (!hasTierData(ladder)) continue;
        const quantity = Number(item?.quantity) || 1;
        if (quantity <= 0) continue;

        const cond = resolveTierCondPrefix(item, ladder);
        const cash = Number(
            (calculateTieredLineTotal(item, `${cond}FinalCash`, currency, ladder, alreadyInCart) / quantity).toFixed(3)
        );
        const credit = Number(
            (calculateTieredLineTotal(item, `${cond}FinalCredit`, currency, ladder, alreadyInCart) / quantity).toFixed(3)
        );

        if (cash !== Number(item.addedCashPrice) || credit !== Number(item.addedCreditPrice)) {
            adjusted++;
        }
        item.addedCashPrice = cash;
        item.addedCreditPrice = credit;
    }

    return adjusted;
}

return {
    roundCurrency,
    getOfferRoundingStep,
    getOfferRoundingDirection,
    hasTierData,
    resolveTierCondPrefix,
    walkTieredLine,
    calculateTieredLineTotal,
    cartCountOffsets,
    applyTieredUnitOffers
};
})();
// ---- END VENDORED BODY ----

export const roundOffer = __offerRounding.roundOffer;
export const resolveIncrement = __offerRounding.resolveIncrement;
export const VALID_ROUNDING = __offerRounding.VALID_ROUNDING;
export const priceGridDigits = __currencyPriceGrid.priceGridDigits;
export const normaliseCode = __buylistMoneyRounding.normaliseCode;
export const isWholeUnitCurrency = __buylistMoneyRounding.isWholeUnitCurrency;
export const roundBuylistMoney = __buylistMoneyRounding.roundBuylistMoney;
export const roundCurrency = __buylistTieredLine.roundCurrency;
export const getOfferRoundingStep = __buylistTieredLine.getOfferRoundingStep;
export const getOfferRoundingDirection = __buylistTieredLine.getOfferRoundingDirection;
export const hasTierData = __buylistTieredLine.hasTierData;
export const resolveTierCondPrefix = __buylistTieredLine.resolveTierCondPrefix;
export const walkTieredLine = __buylistTieredLine.walkTieredLine;
export const calculateTieredLineTotal = __buylistTieredLine.calculateTieredLineTotal;
export const cartCountOffsets = __buylistTieredLine.cartCountOffsets;
export const applyTieredUnitOffers = __buylistTieredLine.applyTieredUnitOffers;
